import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { SelectionTargetHandler } from "./base/SelectionTargetHandler";
export var NodeSelectionHandler = /*#__PURE__*/function (_SelectionTargetHandl) {
  _inherits(NodeSelectionHandler, _SelectionTargetHandl);
  var _super = _createSuper(NodeSelectionHandler);
  function NodeSelectionHandler(selectionStatus, dragStatus) {
    var _this;
    _classCallCheck(this, NodeSelectionHandler);
    _this = _super.call(this);
    _this.selectionStatus = selectionStatus;
    _this.dragStatus = dragStatus;
    return _this;
  }
  _createClass(NodeSelectionHandler, [{
    key: "handleClick",
    value: function handleClick(event, _ref) {
      var nodeId = _ref.nodeId,
        uniqueId = _ref.uniqueId;
      this.selectionStatus.handleSelection({
        nodeId: nodeId,
        uniqueId: uniqueId
      });
      _get(_getPrototypeOf(NodeSelectionHandler.prototype), "handleClick", this).call(this, event);
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(event, _ref2) {
      var nodeId = _ref2.nodeId,
        uniqueId = _ref2.uniqueId;
      if (this.dragStatus.getIsDragging()) return;
      this.selectionStatus.handleHover({
        nodeId: nodeId,
        uniqueId: uniqueId
      });
      _get(_getPrototypeOf(NodeSelectionHandler.prototype), "handleMouseOver", this).call(this, event);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(event) {
      this.selectionStatus.handleLeave();
      _get(_getPrototypeOf(NodeSelectionHandler.prototype), "handleMouseLeave", this).call(this, event);
    }
  }]);
  return NodeSelectionHandler;
}(SelectionTargetHandler);